import { render, staticRenderFns } from "./iframeViews.vue?vue&type=template&id=316c5889&scoped=true&"
import script from "./iframeViews.vue?vue&type=script&lang=js&"
export * from "./iframeViews.vue?vue&type=script&lang=js&"
import style0 from "./iframeViews.vue?vue&type=style&index=0&id=316c5889&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c5889",
  null
  
)

export default component.exports